import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Navigation from './components/Navigation';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import ReplyToEmails from './pages/ReplyToEmails';
import FollowUpSystem from './pages/FollowUpSystem';
import GenerateEmails from './pages/GenerateEmails';
import Settings from './pages/Settings';
import './App.css';

const AppLayout = () => {
  return (
    <div className="flex min-h-screen bg-gray-100">
      <Navigation />
      <div className="ml-64 flex-1">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/reply" element={<ReplyToEmails />} />
          <Route path="/follow-ups" element={<FollowUpSystem />} />
          <Route path="/generate" element={<GenerateEmails />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
      </div>
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/*" element={<ProtectedRoute><AppLayout /></ProtectedRoute>} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
